export const FIND_FILE_REFERENCE_REQUEST = 'FIND_FILE_REFERENCE_REQUEST';

export const findFileReferenceRequest = ( id: string ) => ({
    type: FIND_FILE_REFERENCE_REQUEST,
    payload: { id }
});
